var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-planner',{attrs:{"api-endpoints":_vm.endpoints,"menu-key":"logplanner"},on:{"showHideLoading":_vm.showHideLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }